/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITRESPONDANTDATAGENPOOL, EDITRESPONDANTDATAGENPOOL_RECEIVED } = constants.EditRespondantsDataGenPoolConstants;

export default {
  REQUEST_EDITRESPONDANTDATAGENPOOL,
  EDITRESPONDANTDATAGENPOOL_RECEIVED,

  requestEditResearcherGenPoolData: payload => ({
  type: REQUEST_EDITRESPONDANTDATAGENPOOL,
    payload
  }),
  EditResearcherGenPoolDataReceived: () => ({
    type: EDITRESPONDANTDATAGENPOOL_RECEIVED
  })
};
